// extracted by mini-css-extract-plugin
export var arrows = "_30-6";
export var decrementer = "_30-a";
export var disabled = "_30-4";
export var error = "_30-1";
export var hiddenText = "_30-b";
export var incrementer = "_30-9";
export var input = "_30-8";
export var inputWrapper = "_30-0";
export var leadingIcon = "_30-c";
export var readonly = "_30-3";
export var regular = "_30-7";
export var small = "_30-5";
export var warning = "_30-2";